import {
  useQuery,
} from '@tanstack/react-query';
import { getCustomerOrders } from '../../api/apiStorefront';

export const useGetCustomerOrders = (params = {}) => {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ['customer-orders', params],
    queryFn: () => getCustomerOrders(params),
    select: (response) => response?.data,
  });

  return {
    orders: data?.data || [],
    meta: data?.meta,
    isLoading,
    isError,
    error,
    refetch,
  };
};
